import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { HistoryFamilyComponent } from './family/history-family.component';
import { HistoryItemReadonlyComponent } from './history-item-readonly.component';
import { HistoryItemComponent } from './history-item.component';
import { HistoryPersonalCompleteComponent } from './personal-complete/history-personal-complete.component';
import { HistoryPersonalComponent } from './personal/history-personal.component';

@NgModule({
  declarations: [
    HistoryItemComponent,
    HistoryItemReadonlyComponent,
    HistoryPersonalComponent,
    HistoryPersonalCompleteComponent,
    HistoryFamilyComponent,
  ],
  imports: [CoreModule],
  entryComponents: [],
  exports: [
    HistoryItemComponent,
    HistoryItemReadonlyComponent,
    HistoryPersonalComponent,
    HistoryPersonalCompleteComponent,
    HistoryFamilyComponent,
  ],
})
export class HistoryModule {}
